module.exports = __webpack_public_path__ + "img/parallax1-1024p.683351fa.jpg";